import * as THREE from 'three';

export class ItemHandler {

    modelManager


    constructor(modelManager) {
        this.modelManager = modelManager;
        this.registerAssets()
    }

    registerAssets() {
        // this.modelManager.addModel("deer", "assets/deer/deer.fbx", null)
    }

    addItem(data, scene) {
        console.log("Adding Item", data)
        const added = data.add(this.modelManager, scene)
        console.log("Item added:", added)
        // scene.add(data.obj)
    }
    handleItemSpawn(pt, scene) {
        // console.log("itemModel", itemModel)
        // const item = itemModel.clone();
        // // item.position.set(pt.x, pt.y, pt.z);
        // console.log("Item: ", item)
        //
        // const mixer = new THREE.AnimationMixer(item)
        // var action = mixer.clipAction(itemModel.animations[0]);
        //
        // mixers.push(mixer);
        // action.play();
        //

        const sphere = this.buildDebugSphere(pt)

        scene.add(sphere)
        // scene.add(item)
        return sphere
    }

    removeItem(item, scene) {
        scene.remove(item)
    }


    buildDebugSphere(pt) {
        const geometry = new THREE.SphereGeometry(0.1, 32, 16);
        const material = new THREE.MeshBasicMaterial({color: pt.col});
        const sphere = new THREE.Mesh(geometry, material);

        // sphere.add(new THREE.AxesHelper(0.5));

        // console.log("Adding sphere at: ", pt)
        sphere.position.set(pt.x, pt.y, pt.z);
        return sphere
    }
}